import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Input, Form } from "antd";
import { ContentApi } from "../../../../shared/api/contentApi";
import DialogEditStrings, { DialogEditStringsRow } from "../../_shared/DialogEditStrings";
import AutoApplyEntitiesField from "./AutoApplyEntitiesField";
import SelectParentGroup from "./ParentGroupOrderParameter";

function parseEntityTypes(value) {
    if (Array.isArray(value)) {
        return value.filter(Boolean).map((item) => String(item));
    }
    if (typeof value !== "string") return [];
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
            return parsed.filter(Boolean).map((item) => String(item));
        }
    } catch {
        // Fall back to comma-separated values.
    }
    return trimmed.split(",").map((item) => item.trim()).filter(Boolean);
}

export default function GroupParameterEditDialog({ open, parameter, projectId, versionId, onClose, onSaved  }) {
    return (
        <DialogEditStrings
            open={open}
            entity={parameter}
            projectId={projectId}
            versionId={versionId}
            onClose={onClose}
            onSaved={onSaved}
            title="Редактировать групповой параметр"
            renameSystemName={ContentApi.renameParameterGroupSystemName}
            patchEntity={ContentApi.patchParameterGroup}
            getInitialExtraState={(entity) => ({
                parentGroupId: entity?.parentGroupId || entity?.parentGroupParameterId || null,
                orderIndexText:
                    entity?.orderIndex == null || entity?.orderIndex === ""
                        ? ""
                        : String(entity.orderIndex),
                autoApplyForEntityTypes:
                    parseEntityTypes(entity?.autoApplyForEntityTypes).length > 0
                        ? parseEntityTypes(entity?.autoApplyForEntityTypes)
                        : parseEntityTypes(entity?.autoApplyForEntityTypesJson),
            })}
            buildPayload={({ name, description, extraState }) => ({
                name: name.trim(),
                description: description.trim() || null,
                parentGroupId: extraState.parentGroupId || null,
                autoApplyForEntityTypes: Array.isArray(extraState.autoApplyForEntityTypes)
                    ? extraState.autoApplyForEntityTypes
                    : [],
                orderIndex: (() => {
                    const rawValue = String(extraState.orderIndexText || "").trim();
                    if (!rawValue) return null;
                    const parsed = Number.parseInt(rawValue, 10);
                    return Number.isFinite(parsed) ? parsed : null;
                })(),
            })}
            renderExtraFields={({ extraState, setExtraField }) => (
                <>
                    <SelectParentGroup
                        open={open}
                        projectId={projectId}
                        versionId={versionId}
                        value={extraState.parentGroupId}
                        onChange={(value) => setExtraField("parentGroupId", value)}
                    />

                    <Form.Item name="orderIndex">
                        <DialogEditStringsRow label="Order Index">
                                <Input
                                    type="number"
                                    className="input w-full"
                                    value={extraState.orderIndexText || ""}
                                    onChange={(e) => setExtraField("orderIndexText", e.target.value)}
                                    placeholder="0"
                                />
                        </DialogEditStringsRow>
                    </Form.Item>

                    <AutoApplyEntitiesField
                        open={open}
                        projectId={projectId}
                        versionId={versionId}
                        selectedSystemNames={extraState.autoApplyForEntityTypes}
                        onChange={(next) => setExtraField("autoApplyForEntityTypes", next)}
                    />
                </>
            )}
        />    
    );
}


GroupParameterEditDialog.propTypes = {
    open: PropTypes.bool,
    parameter: PropTypes.object,
    projectId: PropTypes.string,
    versionId: PropTypes.string,
    onClose: PropTypes.func,
    onSaved: PropTypes.func,
};